import * as Yup from "yup"

export const addGeoSchema = Yup.object().shape({
  region: Yup.string().required("This value is required"),
  area: Yup.string().required("This value is required"),
  territories: Yup.string().required("This value is required"),
})
